module.exports = __webpack_public_path__ + "media/components/assets/icons/arrow_right_gray500-71048a58f3e6d1a6fd58e97dd37f4af2.svg";